import { gql } from "@apollo/client";
import { RoomFilters } from "types/rooms";

const ROOM_DATA_TO_RETRIEVE = `
            id
            code
            available
            bathroom
            project_id
            apartment
            createdOn
            updatedOn
            name
            floor
            model
            side
            surface
            plan
            building {
                id
                name
                address
                zone
                complex
                floors
            }
            price
            priceTotal
            priceDetails {
                building {
                    amount
                    excluded
                    show
                }
                taxesVAT {
                    amount
                    excluded
                    show
                }
            }
        `;

interface Params {
  projectId: string;
  range: {
    from: string;
    to: string;
  };
  filters?: RoomFilters;
}

export const GET_ROOMS_DEFAULT_OPTIONS = ({
  projectId,
  range,
  filters,
}: Params) => {
  return {
    variables: {
      projectId,
      range,
      filters,
    },
  };
};

export const GET_AVAILABLE_ROOMS_BY_USER_SELECTION = gql`
  query getRoomSelectorAvailableRoomsByUserSelection(
    $projectId: ID!
    $range: AvailabilityDateRange!
    $filters: RoomFilters
  ) {
    getRoomSelectorAvailableRoomsByUserSelection(
      projectId: $projectId
      range: $range
      filters: $filters
    ) {
      ${ROOM_DATA_TO_RETRIEVE}
    }
  }
`;
